// stores/mapStore.js
import { defineStore } from 'pinia'
import { Map } from 'ol'
import { type Ref } from 'vue'
import { fromLonLat } from 'ol/proj'
import { Polygon } from 'ol/geom'
import { Feature } from 'ol'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'


interface MapStoreState {
  map: Ref<Map | null> | null
  crs: string
}
interface latLonBoundingBox {
  latMin: number
  latMax: number
  lonMin: number
  lonMax: number
}

export const useMapStore = defineStore('mapStore', {
  state: (): MapStoreState => ({
    map: null,
    crs: null
  }),
  actions: {
    setMap(mapInstance: Map) {
      this.map = mapInstance
    },
    setView( box: latLonBoundingBox) {
      if (this.map) {
        if (this.map.getView().getProjection().getCode() === 'EPSG:4326') {
          console.log('EPSG:4326')
          this.map.getView().fit([box.lonMin, box.latMin, box.lonMax, box.latMax])
        } else {
          // convert to 3857
          const min = fromLonLat([box.lonMin, box.latMin])
          const max = fromLonLat([box.lonMax, box.latMax])
          this.map.getView().fit([min[0], min[1], max[0], max[1]])
        }
        // this.map.getView().fit([box.lonMin, box.latMin, box.lonMax, box.latMax])
      }
    },
    drawBox(box: latLonBoundingBox) {
      if (this.map) {
        const extent = [box.lonMin, box.latMin, box.lonMax, box.latMax]
        // convert to 3857
        const min = fromLonLat([box.lonMin, box.latMin])
        const max = fromLonLat([box.lonMax, box.latMax])
        const extent3857 = [min[0], min[1], max[0], max[1]]
        const geometry = new Polygon([[
          [extent3857[0], extent3857[1]],
          [extent3857[0], extent3857[3]],
          [extent3857[2], extent3857[3]],
          [extent3857[2], extent3857[1]],
          [extent3857[0], extent3857[1]]
        ]])
        const feature = new Feature({
          geometry: geometry
        })
        const vectorSource = new VectorSource({
          features: [feature]
        })
        const vectorLayer = new VectorLayer({
          source: vectorSource
        })
        this.map.addLayer(vectorLayer)
      }
    }

  }
})
